var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderDetailsCashicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 21.3389C21.3248 21.4073 23.1143 22.8317 23.1143 22.8317C23.1143 22.8317 22.0674 22.4459 20.3365 22.0853C18.2868 21.6584 16.25 21.3389 16.25 21.3389Z",
    fill: "#FFBA8A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8357 8.08594C16.8357 8.08594 16.7794 10.1981 16.8357 11.0746C16.892 11.9511 16.0703 14.8811 16.0703 14.8811C16.0703 14.8811 17.1385 12.7454 17.1659 11.3211C17.1933 9.89752 16.8357 8.08594 16.8357 8.08594Z",
    fill: "#FFBA8A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8146 10.0938C22.8146 10.0938 22.9736 12.2013 23.1189 13.0672C23.2642 13.933 22.7461 16.9315 22.7461 16.9315C22.7461 16.9315 23.5906 14.6977 23.4727 13.2787C23.3548 11.8597 22.8146 10.0938 22.8146 10.0938Z",
    fill: "#FFBA8A"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9084 23.9723C15.5784 21.466 10.7829 20.8627 2.36719 20.7044C2.60381 14.696 2.8838 11.7758 3.67964 6.19043C13.1757 7.40931 18.4339 8.59776 29.5383 12.3792C27.9048 16.7206 27.1615 19.0572 25.9084 23.973V23.9723Z",
    fill: "#8EAB60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1369 12.3696C27.1422 12.3537 27.1575 12.3445 27.1635 12.3293C17.8957 9.37417 13.4874 8.38963 5.3837 7.25977C5.38141 7.27879 5.38826 7.29629 5.38522 7.31607C5.29163 7.93312 4.77046 8.37441 4.2158 8.32267C3.66952 12.378 3.46105 14.4696 3.20312 18.7471C3.67561 18.7829 4.02179 19.2706 4.03396 19.8716C11.3578 20.1988 15.4253 20.7466 24.1088 22.7674C24.2929 22.2683 24.8536 21.9769 25.4364 22.1222C26.3601 18.5964 26.8805 16.899 28.0058 13.6692C27.3492 13.4599 26.9596 12.8786 27.1361 12.3704L27.1369 12.3696Z",
    fill: "#C3DB7B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5845 15.9099C18.9728 18.4588 16.3814 20.1844 13.8113 19.7978C11.2404 19.4106 9.50721 16.8785 9.93632 14.0991C10.3654 11.3197 12.9485 9.53017 15.702 10.1472C18.4555 10.765 20.1963 13.3611 19.5845 15.9099Z",
    fill: "#8EAB60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.84914 13.5857C5.96099 12.637 6.73324 11.9545 7.57397 12.0656C8.4147 12.1774 8.98761 13.022 8.8537 13.9471C8.71979 14.8723 7.94754 15.5472 7.12888 15.459C6.31021 15.3707 5.73806 14.5345 5.8499 13.585L5.84914 13.5857Z",
    fill: "#8EAB60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M21.239 16.299C21.4497 15.4712 22.3795 14.9994 23.3153 15.2497C24.2512 15.4993 24.8248 16.3545 24.5958 17.1549C24.3668 17.9553 23.4363 18.4217 22.5187 18.198C21.6004 17.9751 21.0282 17.126 21.239 16.299Z",
    fill: "#8EAB60"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67964 6.18945C2.8838 11.7749 2.60381 14.6958 2.36719 20.7042C10.7836 20.8625 15.5792 21.4658 25.9084 23.9721C27.1615 19.0562 27.9048 16.7204 29.5383 12.3782C18.4331 8.59678 13.1757 7.40834 3.67964 6.18945Z",
    fill: "#8EAB60"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9706 24.496C14.021 20.7534 9.33425 19.5725 1 18.3932C1.96475 12.4578 2.59701 9.5932 4.06543 4.14551C13.3431 6.50871 18.4179 8.32638 28.9807 13.4294C26.8321 17.5403 25.811 19.7688 23.9698 24.496H23.9706Z",
    fill: "#8EAB60"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6021 13.1283C26.6097 13.1131 26.6257 13.1055 26.6341 13.091C17.7931 9.03191 13.5369 7.5201 5.62953 5.41406C5.62496 5.43308 5.62953 5.45134 5.6242 5.47037C5.45606 6.07144 4.88542 6.44578 4.34142 6.32784C3.30668 10.2866 2.84561 12.337 2.07031 16.5522C2.53519 16.645 2.81974 17.1707 2.75887 17.7695C9.98839 18.9838 13.96 20.0216 22.3338 23.0818C22.5773 22.6085 23.1692 22.3879 23.7299 22.6024C25.0751 19.2151 25.7979 17.5938 27.3067 14.5245C26.6805 14.2369 26.3647 13.613 26.6013 13.1298L26.6021 13.1283Z",
    fill: "#C3DB7B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6739 15.7247C17.7571 18.18 14.9755 19.5784 12.4708 18.8822C9.96612 18.186 8.55324 15.4622 9.31636 12.7551C10.0795 10.0488 12.8611 8.58564 15.5187 9.53289C18.1771 10.4802 19.59 13.2687 18.6732 15.7239L18.6739 15.7247Z",
    fill: "#8EAB60"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.31902 11.7496C5.54499 10.8214 6.39485 10.237 7.21503 10.4501C8.03522 10.6631 8.50161 11.5708 8.25662 12.4732C8.01163 13.3756 7.16253 13.9515 6.36061 13.7644C5.55868 13.5772 5.09229 12.6771 5.31902 11.7489V11.7496Z",
    fill: "#8EAB60"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20.2681 16.3111C20.5777 15.5153 21.5577 15.1599 22.4563 15.5213C23.3548 15.8827 23.8204 16.8011 23.4963 17.568C23.1722 18.335 22.1915 18.6842 21.3074 18.3509C20.4233 18.0177 19.9577 17.1062 20.2681 16.3103V16.3111Z",
    fill: "#8EAB60"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06543 4.14551C2.59701 9.5932 1.96475 12.4578 1 18.3932C9.33425 19.5725 14.021 20.7534 23.9706 24.496C25.811 19.7688 26.8328 17.5403 28.9815 13.4294C18.4179 8.32638 13.3431 6.50871 4.06543 4.14551Z",
    fill: "#8EAB60"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0193 27.6194C14.2445 21.6209 9.97161 19.3604 2.15625 16.2348C4.50344 10.6988 5.79764 8.06629 8.51764 3.12305C16.9691 7.62196 21.4664 10.5938 30.5151 18.0593C27.4519 21.5425 25.9303 23.4652 23.0193 27.6194Z",
    fill: "#8EAB60"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2749 17.2005C28.2856 17.1876 28.3031 17.1838 28.3145 17.1716C20.6916 11.1297 16.9163 8.65005 9.73552 4.72559C9.72715 4.74309 9.72715 4.76135 9.71726 4.77885C9.4114 5.32285 8.76849 5.55111 8.2671 5.30688C6.32162 8.90646 5.38655 10.7888 3.63281 14.6988C4.06269 14.8997 4.21333 15.4779 4.01247 16.0448C10.7474 18.9413 14.3584 20.8929 21.7652 25.8544C22.1136 25.4527 22.7421 25.3789 23.2351 25.7205C25.3465 22.7494 26.4337 21.3464 28.6287 18.723C28.0885 18.2946 27.9295 17.6136 28.2749 17.2005Z",
    fill: "#C3DB7B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9538 17.8403C18.4801 20.0072 15.4459 20.7057 13.1785 19.4343C10.9112 18.1629 10.1854 15.1811 11.5701 12.7335C12.9541 10.2858 16.0035 9.52497 18.3606 11.0771C20.7177 12.6292 21.4276 15.6734 19.9538 17.8403Z",
    fill: "#8EAB60"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.93168 10.8082C8.37221 9.95982 9.33543 9.59461 10.0826 9.99634C10.829 10.3981 11.0663 11.391 10.6136 12.2089C10.1609 13.0268 9.2 13.3852 8.46503 13.0131C7.73082 12.6411 7.49115 11.6558 7.93168 10.8082Z",
    fill: "#8EAB60"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M21.3651 18.7888C21.8551 18.0895 22.8914 17.9769 23.6781 18.5415C24.4648 19.106 24.6991 20.1088 24.2023 20.7769C23.7047 21.4449 22.67 21.5514 21.8901 21.0181C21.1103 20.4847 20.8752 19.488 21.3651 18.7888Z",
    fill: "#8EAB60"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51764 3.12305C5.79764 8.06629 4.50344 10.6988 2.15625 16.2348C9.97237 19.3604 14.2445 21.6209 23.0193 27.6194C25.9303 23.4652 27.4519 21.5425 30.5151 18.0593C21.4664 10.5938 16.9691 7.62272 8.51764 3.12305Z",
    fill: "#8EAB60"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5153 29.7043C14.9617 22.2259 11.1659 19.2343 4.03906 14.7544C7.3434 9.73048 9.09029 7.37337 12.6548 3C20.159 8.94529 24.0492 12.6773 31.6081 21.6484C27.9683 24.5237 26.1255 26.1413 22.5153 29.7043Z",
    fill: "#8EAB60"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5556 20.4C29.5685 20.3893 29.586 20.3886 29.5997 20.3794C23.1874 13.0646 19.9195 9.94588 13.5612 4.79492C13.5498 4.81014 13.5467 4.82916 13.5338 4.84362C13.1351 5.32371 12.461 5.43251 12.0129 5.10231C9.4519 8.29331 8.19347 9.97708 5.76562 13.5082C6.15213 13.7829 6.19702 14.3786 5.89725 14.9005C12.0015 18.9604 15.2023 21.5298 21.5964 27.7422C22.0119 27.4097 22.6426 27.45 23.0664 27.8746C25.6776 25.3318 26.9992 24.1464 29.6302 21.9612C29.1759 21.4423 29.1425 20.7446 29.5556 20.4Z",
    fill: "#C3DB7B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2584 19.5349C19.4187 21.402 16.3091 21.5427 14.3066 19.8849C12.3048 18.227 12.1268 15.163 13.9284 13.0037C15.7301 10.8444 18.8671 10.6451 20.9061 12.5951C22.9459 14.5452 23.0973 17.6677 21.2576 19.5349H21.2584Z",
    fill: "#8EAB60"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.6938 10.4555C11.2797 9.70073 12.2931 9.51432 12.955 10.0439C13.617 10.5734 13.6717 11.5922 13.0798 12.3158C12.4879 13.0393 11.4775 13.2189 10.8216 12.7205C10.1658 12.223 10.1072 11.2103 10.693 10.4555H10.6938Z",
    fill: "#8EAB60"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22.4786 20.7207C23.0865 20.1211 24.1258 20.1965 24.7984 20.8934C25.4709 21.5903 25.5212 22.619 24.9117 23.1866C24.3023 23.7549 23.2653 23.6728 22.5942 23.0078C21.9231 22.3428 21.8706 21.3202 22.4786 20.7207Z",
    fill: "#8EAB60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDetailsCashicon);
export default __webpack_public_path__ + "static/media/order-details-cashicon.523a35138258414dbbc02a1ad5537133.svg";
export { ForwardRef as ReactComponent };